import { jsx as _jsx } from "react/jsx-runtime";
import PortableText from '@helsenorge/core-cms/richtext';
import styles from './styles.module.scss';
const HelpText = props => {
    return _jsx(PortableText, { value: props.value, className: styles.portabletext, backgroundColor: "cherry" });
};
export default HelpText;
